import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";

export interface ErrorBannerProps {
  title?: string;
  message: string;
}

export function ErrorBanner({ title = "Error", message }: ErrorBannerProps) {
  return (
    <Alert className="border-destructive/40 bg-destructive/10 text-destructive">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
